import * as React from "react";
import { Component } from "react";
import ModalPanel from "Panels/ModalPanel";
import UserForm, { CreatedUserDetails } from "Forms/Composite/UserForm";
import UserCreatedSuccessModal from "./UserCreatedSuccessModal";
import User from "../../../Model/User";

interface UserFormModalPanelProps {
    shouldBeShown: boolean;
    initialUser?: User;
    onClose(): void;
    onUserUpdated(): void;
}

interface UserFormModalPanelState {
    isSaving: boolean;
    showSuccessModal: boolean;
    createdUser?: CreatedUserDetails;
}

export default class UserFormModalPanel extends Component<UserFormModalPanelProps, UserFormModalPanelState> {
    constructor(props: UserFormModalPanelProps) {
        super(props);

        this.state = {
            isSaving: false,
            showSuccessModal: false,
            createdUser: undefined
        }
    }

    render() {
        const { isSaving, showSuccessModal, createdUser } = this.state;

        return (
            <>
                <ModalPanel
                    content={
                        <UserForm initialUser={this.props.initialUser}
                            onSave={() => this.onSave()}
                            onSaveComplete={(createdUserDetails) => this.onSaveComplete(createdUserDetails)}
                            onSaveFailed={() => this.onSaveFailed()}
                            onCancel={() => this.props.onClose()} />
                    }
                    title={this.formTitle()}
                    titleAlignment="centre"
                    onClose={() => !isSaving && this.props.onClose()}
                    shouldBeShown={this.props.shouldBeShown && !showSuccessModal}
                />
                {createdUser && (
                    <UserCreatedSuccessModal
                        shouldBeShown={showSuccessModal}
                        username={createdUser.username}
                        email={createdUser.email}
                        password={createdUser.password}
                        onClose={() => this.onSuccessModalClose()}
                    />
                )}
            </>
        );
    }

    formTitle() {
        if (this.props.initialUser) {
            return "Edit User";
        } else {
            return "Create User";
        }
    }

    private onSave() {
        this.setState({ isSaving: true });
    }

    private onSaveComplete(createdUser?: CreatedUserDetails) {
        this.setState({ isSaving: false });

        if (createdUser) {
            // New user created - show success modal
            this.setState({
                showSuccessModal: true,
                createdUser
            });
        } else {
            // Existing user updated - just close
            this.props.onClose();
            this.props.onUserUpdated();
        }
    }

    private onSuccessModalClose() {
        this.setState({
            showSuccessModal: false,
            createdUser: undefined
        });
        this.props.onClose();
        this.props.onUserUpdated();
    }

    private onSaveFailed() {
        this.setState({ isSaving: false });
    }
}
